import React from 'react'
import classNames from 'classnames'
import { WemoloButton, WemoloSpace, WemoloTypography } from '../../components/Wemolo'
import { AccessControlSite, useSetSiteLiveStatusMutation } from '../../views/AccessControl'
import { ToastTypes, launchToast } from '../../components'
import { useAccessControlStore } from '../AccessControl/AccessControlStore'
import styles from './LotAccessControl.module.css'

interface LotAccessControlProps {
    site: AccessControlSite | null | undefined
}

export const LotAccessControl = ({ site }: LotAccessControlProps) => {
    const { mutate: setSiteLiveStatus, isLoading } = useSetSiteLiveStatusMutation()
    const { setSites, sites } = useAccessControlStore()

    if (!site) {
        return null
    }

    const isLive = site.live || false

    const handleToggleLive = () => {
        setSiteLiveStatus(
            { site: site.site, live: !isLive },
            {
                onSuccess: (data) => {
                    const updatedSites = sites.map((s) => (s.site === data.site ? { ...s, live: data.live } : s))
                    setSites(updatedSites)
                    launchToast(ToastTypes.Success, `Lot successfully taken ${data.live ? 'online' : 'offline'}!`)
                },
                onError: (error) => {
                    launchToast(
                        ToastTypes.Error,
                        'Error: Could not update lot status. Check the console for more details !'
                    )
                    console.error('Failed to update lot status:', error)
                }
            }
        )
    }
    const statusText = isLive ? 'Online' : 'Offline'

    return (
        <WemoloSpace direction="vertical" align="center" className={styles.container}>
            <div className={styles.content}>
                <WemoloTypography variant="headline-medium" tag="h2">
                    Access Control Management
                </WemoloTypography>

                <div className={classNames(styles.statusBox, { [styles.statusBoxLive]: isLive })}>
                    <WemoloTypography
                        variant="title-large"
                        tag="div"
                        className={classNames(styles.statusText, { [styles.statusTextLive]: isLive })}
                    >
                        Status: {statusText}
                    </WemoloTypography>
                </div>

                <WemoloTypography variant="body-medium" tag="p" className={styles.description}>
                    While inactive, automated access via our systems is fully disabled for this lot. License plates
                    won&apos;t be recognized and PIN entry won&apos;t open any roller shutters.
                </WemoloTypography>
            </div>

            <WemoloButton onClick={handleToggleLive} view={isLive ? 'secondary' : 'primary'} disabled={isLoading}>
                {isLoading ? 'Updating...' : isLive ? 'Take Offline' : 'Take Online'}
            </WemoloButton>
        </WemoloSpace>
    )
}
